define(function (require) {

    window.lpTag = window.lpTag || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpSecureFormsController = require('web-agent-assets-js/lpSecureFormsController');
    var lpCoBrowseController = require('web-agent-assets-js/lpCoBrowseController');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var userProfilesPath = 'userProfiles.';
    var webAgentUtils = require('web-agent-utils/WebAgentUtils');

    var EngagementOrbViewController = ViewController.extend({
        ControllerName: "EngagementOrbViewController",
        ShowTimer: true,
        StopTimerOnFocus: false,

    initialize : function (constructorData) {
        this.focused = false;
        this.externalVisible = true;
        this.previouslyFocused = false;
        this.notificationTooltipShowing = false;
        this.notificationTooltipCreated = false;
        this.visitorId = constructorData.visitorId;
        this.widgetNotifications = [];this.clearNotificationCounter();
        this.defaultNotificationTooltipTimeOut = 5000;
        this.engagementState = this.engagementStates.active;
        this.chatsResumed = this.getModelParam("agent.chatsResumedCount") !== null;
        this.timerIsActive = false;
        this.participantRoles = lpTag.AMSStatics.participant.roles;
        this.asyncMessaging = lpTag.WebAgent.logicController.isVisitorAsyncMessaging(this.visitorId);
        this.isAutoAccepted = constructorData.isAutoAccepted;
        this.isOnlinePresenceEnabled = lpTag.WebAgent.logicController.getOnlinePresenceSiteSetting().enabled;
        var eventChannel = webAgentStatics.COMMUNICATION_CHANNELS.QUEUE_ORB;
        lpTag.WebAgent.channel.bind(eventChannel.name, eventChannel.events.acceptSuccess, this.onNewAcceptedEngagement.bind(this));
        lpTag.WebAgent.channel.bind(eventChannel.name, eventChannel.events.visitorChange, this.onStepUp.bind(this));
        var appEventsChannel = webAgentStatics.COMMUNICATION_CHANNELS.AppEvents;
        lpTag.WebAgent.channel.bind(appEventsChannel.name, appEventsChannel.events.sdkNotification, this.onWidgetNotification.bind(this));
        lpTag.WebAgent.channel.bind(appEventsChannel.name, appEventsChannel.events.sdkNotificationViewed, this.onWidgetNotificationViewed.bind(this));
        if (this.asyncMessaging) {
            this.addClass(this.LPViewMap.orbState, this.engagementOrbStates.chatMessaging);
            this.addClass(this.LPViewMap.orbState, this.LPClassesMap.closeButton);
            this.lpHide(this.LPViewMap.orbSerialNumber);
            this.ShowTimer = false;
            var channel = this.getFirstElement(this.LPViewMap.orbCurrentChannel);
            if (channel) {
                channel.className = channel.className + " hide";
            }
            this.isAutoOpen = lpTag.WebAgent.logicController.isAutoOpenConversation(this.visitorId);
        } else {
            this.lpHide(this.LPViewMap.orbAvatar);
            this.addClass(this.LPViewMap.orbState,this.engagementOrbStates.chatRealTime);
        }
    },
    events : function () {

        this.viewEventsHandler.bindEvent({appName : this.visitorId, UIEvent : this.eventType.VISITOR_FOCUSED, callback : this.lpFocus});
        this.viewEventsHandler.bindEvent({appName : this.visitorId, UIEvent : this.eventType.VISITOR_BLURRED, callback : this.lpBlur});
        this.viewEventsHandler.bindEvent({appName : this.visitorId, UIEvent : this.eventType.VISITOR_DISPOSED, callback : this.visitorDisposed});
        this.bindViewEvent({selector: '.engagement_orb_close_btn', DOMEvent: "click", callback: this.hideEngagement});
        this.bindViewEvent({selector: this.LPViewMap.orbCustomAvatar, DOMEvent: "load", callback: this.onAvatarImgLoad});

        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
        this.bindModel({modelPath : participantPath + ".chats", callback : this.setChatId});
        this.bindModel({modelPath : participantPath + ".participantState.engagementState", callback : this.handleEngagementStateChanged});
        this.bindModel({modelPath : participantPath + ".participantInfo.visitorSerialNumber", callback : this.setVisitorSerialNumber});
        this.bindModel({modelPath : participantPath + '.participantInfo.acceptedEngagement', callback : this.handleAcceptedEngagement});
        this.bindModel({modelPath : participantPath + '.participantInfo.spectatedEngagement', callback : this.handleSpectatedEngagement});

        if (lpTag.WebAgent.logicController.hasSentimentAnalysisFeature()) {
            this.bindModel({modelPath: participantPath + '.participantInfo.sentimentScore', callback: this.updateEngagementSentiment});
        }
        this.bindModel({modelPath : "agent.status", callback : this.statusChanged});
        this.bindModel({modelPath : "agent.agentName", callback: this.handleAgentNameChange});
        var that = this;
        setTimeout(function() { // This timeout is necessary to make sure that the chats resume state will be updated only after the initial load of the current chat lines is done.
            that.bindModel({modelPath : "agent.chatsResumedCount", callback : that.handleChatsResumeState});
        },0);
        this.bindViewEvent({appName : this.visitorId, DOMEvent : "click", UIEvent : this.eventType.VISITOR_FOCUSED});//TODO - implement signaling to controller
        agentLEManager.onLEEvent("focusStatus:change", this.externalVisibilityChanged, this);
        // async bind
        //this.bindModel({modelPath : "participants.info."+this.visitorId+".data.async", callback: this.handleAsyncChange});

            if (lpTag.WebAgent.logicController.hasCoBrowseFeature()) {
                agentLEManager.onLEEvent(lpCoBrowseController.NOTIFICATION_CHANNEL_IDENTIFIER, this.onCoBrowseNotification, this);
            }

            // offline messaging bind
            this.bindModel({modelPath : "participants.info."+this.visitorId+".data.async", callback: this.handleOfflineChange});

            var infoPath = lpTag.WebAgent.logicController.getParticipantDataPath(this.visitorId);
            this.bindModel({modelPath: infoPath + '.data.participant.isAuthenticated', callback: this.showAuthChatIcon});
        },
        render: function () {
        }
    });

    EngagementOrbViewController.prototype.engagementStates = {
        active: "active",
        inactive: "inactive",
        completed: "completed"
    };

    EngagementOrbViewController.prototype.engagementOrbStates = {
        blur : "engagement_hidden",
        focus : "eng_orb_focused",
        spectated : "spectated",
        show : "eng_orb_event",
        closingLoading : "offline_engagement_loading",
        warning : "warning",
        tooltipLine : "line",
        tooltipInfo : "info",
        tooltipWidgetNotification : "tooltipWidgetNotification",
        widgetNotification : "widget_notification",
        tooltipInfoLoading : "info_loading",
        tooltipStepUp : "tooltipStepUp",
        tooltipWarning : "warning",
        tooltipTryAgainButton : "try_again",
        timer : "show_timer",
        newEngagement : "new_engagement",
        cobrowsing: 'cobrowsing',
        chatMessaging: 'chatMessaging',
        chatRealTime : 'chatRealTime'
    };

    EngagementOrbViewController.prototype.LPViewMap = {
        orbState: ".lpview_engagement_orb_state",
        orbSerialNumber: ".lpview_engagement_orb_serial_number",
        orbAvatar: ".lpview_engagement_orb_avatar",
        orbCustomAvatar: ".lpview_engagement_orb_avatar_customImage",
        orbBadge: ".lpview_engagement_orb_badge",
        orbCurrentChannel: ".lpview_engagement_orb_current_channel",
        orbVisitorName: ".lpview_engagement_orb_visitor_name",
        orbAgentName: ".lpview_engagement_orb_agent_name",
        orbNotificationTimestamp: ".lpview_engagement_orb_notification_timestamp",
        orbNotificationCounter: ".lpview_engagement_orb_notification_counter",
        orbNotificationTimer: ".lpview_timer",
        notificationTooltip: ".lpview_engagement_orb_notification_tooltip",
        notificationTooltipState: ".lpview_notification_tooltip_state",
        notificationTooltipText: ".lpview_notification_tooltip_text",
        notificationTooltipTimestamp: ".lpview_notification_tooltip_timestamp",
        notificationTooltipClose: ".lpview_notification_tooltip_close"
    };

    EngagementOrbViewController.prototype.LPClassesMap = {
        negative : "sentiment_negative",
        closeButton : "close_button",
        showCustomImage : "showCustomImage",
        showDefaultImage : "showDefaultImage",
        tooltipOn: "tooltipOn",
        participateAsManager: 'participate_as_manager',
        participateAsReader: 'participate_as_reader',
        onlinePresence: "online_presence"
    };

    EngagementOrbViewController.prototype.showAuthChatIcon = function (data) {
        if (data && typeof data.newValue !== "undefined" && data.newValue) {
            this.addClass(this.LPViewMap.orbState, 'auth');
        }
    };

    EngagementOrbViewController.prototype.visitorDisposed = function () {
        if (lpTag.WebAgent.logicController.hasCoBrowseFeature()) {
            agentLEManager.offLEEvent(lpCoBrowseController.NOTIFICATION_CHANNEL_IDENTIFIER, this.onCoBrowseNotification, this);
        }
        this.dispose();
    };

    EngagementOrbViewController.prototype.statusChanged = function (data) {
        if (data.newValue !== 'loggedIn' && typeof data.newValue !== 'undefined') {
            this.dispose();
        }
    };

    EngagementOrbViewController.prototype.handleAgentNameChange = function (data) {
        if (data && data.newValue) {
            this.agentName = data.newValue;
        }
    };

    EngagementOrbViewController.prototype.handleTagChanged = function (data) {
        if (!data.newValue) {
            return;
        }
        if (this.color) {
            this.removeClass(this.LPViewMap.orbState, this.color);
        }
        this.color = data.newValue;
        this.addClass(this.LPViewMap.orbState, this.color);
    };
    EngagementOrbViewController.prototype.handleAvatar = function (data) {
        if (!data.newValue || !webAgentUtils.isSecureUrl(data.newValue)) {
            this.addClass(this.LPViewMap.orbAvatar, this.LPClassesMap.showDefaultImage);
            this.removeClass(this.LPViewMap.orbAvatar, this.LPClassesMap.showCustomImage);
            return;
        }
        var avatar = this.getFirstElement(this.LPViewMap.orbCustomAvatar);
        avatar.setAttribute('src', data.newValue);
    };
    EngagementOrbViewController.prototype.onAvatarImgLoad = function () {
        this.removeClass(this.LPViewMap.orbAvatar, this.LPClassesMap.showDefaultImage);
        this.addClass(this.LPViewMap.orbAvatar, this.LPClassesMap.showCustomImage);
    };
    EngagementOrbViewController.prototype.handleOfflineChange = function (data) {
        if (!data.newValue) {
            return;
        }
        if (data.newValue) {
            this.addClass(this.LPViewMap.orbState, "offlineMessaging");
        }
    };
    EngagementOrbViewController.prototype.handleSpectatedEngagement = function (data) {
        if (!data.newValue) {
            return;
        }
        if (this.asyncMessaging) {
            this.lpHide(this.LPViewMap.orbAvatar);
        } else {
            this.bindModel({modelPath: "chats." + this.chatId + ".agentInfo.agentName", callback: this.updateAgentName});
        }
        this.addClass(this.LPViewMap.orbState, [this.engagementOrbStates.spectated, this.LPClassesMap.closeButton]);
    };

    EngagementOrbViewController.prototype.handleAcceptedEngagement = function (data) {
        if (!data.newValue) {
            return;
        }
        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
        this.bindModel({modelPath : participantPath + ".participantTag", callback : this.handleTagChanged});
        this.bindModel({modelPath : participantPath + ".participantInfo.imageUrl", callback : this.handleAvatar});
        this.bindModel({ modelPath: userProfilesPath + this.visitorId + ".imgUrl", callback : this.handleAvatar});
        this.removeClass(this.LPViewMap.orbState, this.engagementOrbStates.spectated);
        if (this.asyncMessaging) {
            this.removeClass(this.LPViewMap.orbState, this.LPClassesMap.participateAsManager);
            this.removeClass(this.LPViewMap.orbState, this.LPClassesMap.participateAsReader);
            this.lpShow(this.LPViewMap.orbAvatar);
        } else {
            this.removeClass(this.LPViewMap.orbState, this.LPClassesMap.closeButton);
        }
        this.notifyOnNewEngagement();
    };


    /**
     * For the current visitorId, looks in the model at the badges.
     * Decides which 1 badge has a higher priority and shows it in the orb.
     * Removes any old badge.
     * @param data from callback
     * @private
     */
    EngagementOrbViewController.prototype.decideWhichBadgeToShow = function (data) {
        if (!data.newValue) {
            return;
        }
        this.badgeToShow = "";

        //find out what it the badge that needs to be shown. Consider the priority - overdue > urgent > first time
        this.conversationBadges = this.getModelParam("chats." + this.chatId + ".chatInfo.badges");
        if (this.conversationBadges.overdue) {
            this.badgeToShow = "overdue";
        } else if (this.conversationBadges.urgent) {
            this.badgeToShow = "urgent";
        } else if (this.conversationBadges.first_time) {
            this.badgeToShow = "first_time";
        }

        //remove the current badge
        var orbView = this.getFirstElement(this.LPViewMap.orbBadge);
        this.removeClass(orbView, "first_time_badge");
        this.removeClass(orbView, "overdue_badge");
        this.removeClass(orbView, "urgent_badge");

        //add the new badge
        if (this.badgeToShow !== "") {
            this.addClass(this.getFirstElement(this.LPViewMap.orbBadge), this.badgeToShow + "_badge");
        }
    };

EngagementOrbViewController.prototype.onlinePresenceChanged = function (data) {
    var orbState = this.getFirstElement(this.LPViewMap.orbState);
    if(data.newValue) {
        this.addClass(orbState, this.LPClassesMap.onlinePresence);
    }
    else {
        this.removeClass(orbState, this.LPClassesMap.onlinePresence);
    }
};

EngagementOrbViewController.prototype.updateAgentName = function (data) {
    if(data.newValue){
        this.getFirstElement(this.LPViewMap.orbAgentName).innerHTML = data.newValue; //TODO check if & is multi language
    }
};

    EngagementOrbViewController.prototype.setVisitorSerialNumber = function (data) {
        if (!data.newValue) {
            return;
        }
        this.getFirstElement(this.LPViewMap.orbSerialNumber).innerHTML = data.newValue;
    };

    EngagementOrbViewController.prototype.updateParticipantName = function (data) {
        // Handle visitor name, if none defined use a custom one, otherwise use what the the user defined.
        if (typeof data.newValue !== 'undefined' && data.newValue) {
            var visitorName = data.newValue === 'visitor' ? this.translate('participantDefaultName') : data.newValue;
            lpUtils.setElementText(this.getFirstElement(this.LPViewMap.orbVisitorName), visitorName);
        }
    };

    EngagementOrbViewController.prototype.setChatId = function (data) {
        var chatIds = Object.keys(data.newValue);
        for (var chat in chatIds) {
            unbindChat.call(this);
            this.chatId = chatIds[chat];
            bindChat.call(this);
        }
        function unbindChat() {
            if (this.chatId) {
                this.unbindModel({
                    modelPath: 'chats.' + this.chatId + '.visitorInfo.visitorName',
                    callback: this.updateParticipantName
                });
                this.unbindModel({
                    modelPath: userProfilesPath + this.visitorId + '.fullName',
                    callback: this.updateParticipantName
                });
                this.unbindModel({ modelPath: userProfilesPath + this.visitorId + ".imgUrl", callback: this.handleAvatar });
                this.unbindModel({modelPath: 'chats.' + this.chatId + '.newChatLine.lines', callback: this.newChatLine});
                if (this.asyncMessaging) {
                    this.unbindModel({
                        modelPath: "chats." + this.chatId + ".chatInfo.SlaTexts.text",
                        callback: this.setMessagingSla
                    });
                    this.unbindModel({
                        modelPath: "chats." + this.chatId + ".chatInfo.badges",
                        callback: this.decideWhichBadgeToShow
                    });
                    this.unbindModel({
                        modelPath: 'chats.' + this.chatId + '.agentInfo.loggedInAgentUnreadCount',
                        callback: this.updateUnreadCounter
                    });
                    if(this.isOnlinePresenceEnabled) {
                    this.unbindModel({
                        modelPath: "chats." + this.chatId + ".visitorInfo.isOnlinePresence",
                        callback: this.onlinePresenceChanged
                    });
                }
                if (lpTag.WebAgent.logicController.agentCanViewChat(this.getModelParam('chats.'  + this.chatId + '.chatInfo'))) {
                        this.unbindModel({
                            modelPath: 'chats.' + this.chatId + '.chatInfo.allParticipantsHash',
                            callback: this.onLoggedInParticipantRoleChanged,
                            context: this
                        });
                    }
                }
            }
        }

        function bindChat() {
            if (this.chatId) {
                this.bindModel({
                    modelPath: 'chats.' + this.chatId + '.visitorInfo.visitorName',
                    callback: this.updateParticipantName
                });
                this.bindModel({
                    modelPath: userProfilesPath + this.visitorId + '.fullName',
                    callback: this.updateParticipantName
                });
                this.bindModel({
                    modelPath: userProfilesPath + this.visitorId + ".imgUrl",
                    callback: this.handleAvatar
                });
                this.bindModel({
                    modelPath: 'chats.' + this.chatId + '.newChatLine.lines',
                    callback: this.newChatLine,
                    trigger: false
                });
                if (this.asyncMessaging) {
                    this.bindModel({
                        modelPath: "chats." + this.chatId + ".chatInfo.SlaTexts.text",
                        callback: this.setMessagingSla
                    });
                    this.bindModel({
                        modelPath: "chats." + this.chatId + ".chatInfo.badges",
                        callback: this.decideWhichBadgeToShow
                    });
                    this.bindModel({
                        modelPath: 'chats.' + this.chatId + '.agentInfo.loggedInAgentUnreadCount',
                        callback: this.updateUnreadCounter
                    });
                    if(this.isOnlinePresenceEnabled) {
                    this.bindModel({
                        modelPath: "chats." + this.chatId + ".visitorInfo.isOnlinePresence",
                        callback: this.onlinePresenceChanged
                    });
                }
                if (lpTag.WebAgent.logicController.agentCanViewChat(this.getModelParam(this.chatsRootModelPath + this.chatId + '.chatInfo'))) {
                        this.bindModel({
                            modelPath: 'chats.' + this.chatId + '.chatInfo.allParticipantsHash',
                            callback: this.onLoggedInParticipantRoleChanged,
                            context: this
                        });
                    }
                }
            }
        }
    };

    EngagementOrbViewController.prototype.onLoggedInParticipantRoleChanged = function (data) {

        if (!lpTag.WebAgent.logicController.isSpectatedEngagementByChatId(this.chatId)) {
            return;
        }

        var activeDialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId);
        if (activeDialogId) {
            var role = lpTag.WebAgent.logicController.getLoggedInAgentRoleInConversationDialog(this.chatId, activeDialogId, this.chatsRootModelPath);
            var isReader = role === this.participantRoles.READER;
            var isManager = role === this.participantRoles.MANAGER;

            this.toggleClass(this.LPViewMap.orbState, this.LPClassesMap.participateAsManager, isManager);
            this.toggleClass(this.LPViewMap.orbState, this.LPClassesMap.participateAsReader, isReader);
        }
    };

    EngagementOrbViewController.prototype.updateUnreadCounter = function (data) {
        this.logger.info('received unread count', 'updateUnreadCounter', data);
        data = data || {};
        if (typeof data.newValue === 'number') {
            this.setNotificationCounter(data.newValue);
        }
    };

    EngagementOrbViewController.prototype.focusOrb = function () {
        this.focused = true;
        var orbStateElement = this.getFirstElement(this.LPViewMap.orbState);
        this.removeClass(orbStateElement, [this.engagementOrbStates.blur, this.engagementOrbStates.show]);
        this.addClass(orbStateElement, this.engagementOrbStates.focus);
        orbStateElement = null;
    };

    EngagementOrbViewController.prototype.blurOrb = function () {
        this.focused = false;
        var orbStateElement = this.getFirstElement(this.LPViewMap.orbState);
        this.removeClass(orbStateElement, [this.engagementOrbStates.focus, this.engagementOrbStates.show]);
        this.addClass(orbStateElement, this.engagementOrbStates.blur);
        orbStateElement = null;
    };

    EngagementOrbViewController.prototype.notifyOrb = function (newEngagement) {
        this.toggleClass(this.LPViewMap.orbNotificationCounter, this.engagementOrbStates.newEngagement, newEngagement);
        var orbStateElement = this.getFirstElement(this.LPViewMap.orbState);
        this.removeClass(orbStateElement, [this.engagementOrbStates.focus, this.engagementOrbStates.blur]);
        this.addClass(orbStateElement, this.engagementOrbStates.show);
        orbStateElement = null;
    };

    EngagementOrbViewController.prototype.clearNotificationCounter = function () {
        this.notificationCount = 0;
        var newCounterText = (this.widgetNotifications.length !== 0) ? " " : "";this.getFirstElement(this.LPViewMap.orbNotificationCounter).innerHTML = newCounterText;
        if (!this.ShowTimer && !this.asyncMessaging) {
            this.getFirstElement(this.LPViewMap.orbNotificationTimestamp).innerHTML = "";
        }
    };

    EngagementOrbViewController.prototype.setNotificationCounter = function (count) {
        this.notificationCount = count;
        if(this.widgetNotifications.length !== 0) {
        count = count ? ('+' + count) : '';
    }
    if (!this.focused && count) { // only render if count is larger than 0
            this.getFirstElement(this.LPViewMap.orbNotificationCounter).innerHTML = count;
            this.notifyOrb(false);
        }
    };

    EngagementOrbViewController.prototype.onWidgetNotificationViewed = function(data) {
        if(this.chatId === data.chatId) {
            //remove current notification viewed (data.applicationType) from this.widgetNotifications array
            this.widgetNotifications = this.widgetNotifications.filter(function(e) { return e !== data.applicationType; });

            if (this.widgetNotifications.length === 0) {
                var orbStateElement = this.getFirstElement(this.LPViewMap.orbState);
                this.removeClass(orbStateElement, this.engagementOrbStates.widgetNotification);
            }
        }
    };

    EngagementOrbViewController.prototype.onWidgetNotification = function(data) {
        if(this.chatId === data.chatId) {
            //add current notification (data.applicationType) to this.widgetNotifications array (first remove and then add - to ensure there is no duplicates)
            this.widgetNotifications = this.widgetNotifications.filter(function(e) { return e !== data.applicationType; });
            this.widgetNotifications.push(data.applicationType);

            var orbStateElement = this.getFirstElement(this.LPViewMap.orbState);
            this.addClass(orbStateElement, this.engagementOrbStates.widgetNotification);

            this.setNotificationCounter(this.notificationCount);

            if (!this.focused) {
                if (lpTag.WebAgent.logicController.isAcceptedEngagementOrInMyEngagement(this.chatId)) {
                    data.type = this.engagementOrbStates.tooltipWidgetNotification;
                    data.text = "New event in " + data.displayName;
                    this.showNotificationToolTip(data);
                }
            }
        }
    };

    EngagementOrbViewController.prototype.newChatLine = function (data) {
        var visitorLines, firstVisitorLine, lastVisitorLine, agentLines;

        if (typeof data.newValue !== 'undefined' && this.chatsResumed) {

            var lastVisitorIndex = findLastSourceIndex.call(this, "visitor", data);
            var lastAgentIndex = findLastSourceIndex.call(this, "agent", data);

            // If this isn't a visitor line, and we want timers that aren't affected by focus,
            // we need to check if the agent sent a line. If so - we stop the timer
            if (this.ShowTimer && !this.StopTimerOnFocus && this.timerIsActive) {
                agentLines = getAgentLines.call(this, data.newValue, this.agentName);
                if (agentLines.length) {
                    this.stopEngagementOrbTimer();
                }
            }

            visitorLines = getNotificationLines.call(this, data.newValue, this.chatId);
            if (visitorLines.length) {
                firstVisitorLine = visitorLines[0];
                lastVisitorLine = visitorLines[visitorLines.length - 1];
                if ((!this.focused || this.ShowTimer && !this.StopTimerOnFocus) && lastAgentIndex < lastVisitorIndex) {
                    // If we're not focused - we check the new visitor line and set notifications
                    setTimeStampFromChatLine.call(this, firstVisitorLine);
                }
                if (!this.focused) {
                    if (!lpTag.WebAgent.logicController.hasUnreadMessagesCounter(this.chatId)) {
                        // updating the counter with new lines, the async messaging flow will handle it by listening to loggedInAgentUnreadCount
                        this.setNotificationCounter(this.notificationCount + visitorLines.length);
                    }
                    if (lpTag.WebAgent.logicController.isAcceptedEngagementOrInMyEngagement(this.chatId)) {
                        this.showNotificationToolTip(lastVisitorLine);
                    }
                }
            }
        }

        function findLastSourceIndex(source, data) {
            for (var i = data.newValue.length - 1; i >= 0; i--) {
                if (data.newValue[i].source === source) {
                    return i;
                }
            }
            return -1;
        }

        function getNotificationLines(chatLines, chatId) {
            return _.filter(chatLines, function (chatLine) {
                return lpTag.WebAgent.logicController.isLineNeedToBeNotified(chatLine, chatId);
            });
        }

        function getAgentLines(chatLines, agentName) {
            return _.filter(chatLines, function (chatLine) {
                return chatLine.source === "agent" && chatLine.subType === "REGULAR" && chatLine.by === agentName;
            });
        }

        function setTimeStampFromChatLine(chatLine) {
            chatLine = chatLine || {};
            if (!this.timerIsActive || (this.focused && this.ShowTimer && !this.StopTimerOnFocus)) {//If it's the first unanswered line we set timestamp
                if (lpTag.WebAgent.logicController.isAcceptedEngagement(this.visitorId)) {//We only show timers for accepted chats
                    this.setTimeStamp(chatLine.time);
                }
            }
        }
    };

    EngagementOrbViewController.prototype.updateEngagementSentiment = function (data) {
        var sentimentTag, negativeSentiment;
        if (typeof data.newValue !== "undefined") {
            sentimentTag = lpTag.WebAgent.logicController.getSentimentTag(data.newValue);
            negativeSentiment = sentimentTag === lpTag.WebAgent.logicController.sentimentMap.negative;
            this.toggleClass(this.LPViewMap.orbState, this.LPClassesMap.negative, negativeSentiment);
        }
    };

    EngagementOrbViewController.prototype.showNotificationToolTip = function (data) {
        this.createNotificationTooltip(); // This will only actually run once
        this.setNotificationTooltipInfo(data); // Set the notification tooltip info
        switch (data["@type"] || data.type) {
            case this.engagementOrbStates.tooltipLine:
            case lpAMSController.CONTENT_TYPES.RICH_CONTENT:
            case lpSecureFormsController.COLLABORATION_EVENT_NAME:
            case this.engagementOrbStates.tooltipWidgetNotification:
                this.showNotificationTooltipLine();
                break;
            case this.engagementOrbStates.tooltipInfo:
                this.showNotificationTooltipInfo();
                break;
            case this.engagementOrbStates.tooltipStepUp:
                this.showNotificationTooltipStepUp();
                break;
            case this.engagementOrbStates.tooltipInfoLoading:
                this.showNotificationTooltipInfoLoading();
                break;
            default:
                break;
        }
        this.notificationTooltipShowing = true;
        this.setNotificationTooltipAutoCloseTime(data.timeout || this.defaultNotificationTooltipTimeOut, data.hideOrbWhenDone ? data.hideOrbWhenDone : false);
        this.addClass(this.LPViewMap.orbState, this.LPClassesMap.tooltipOn);
    };

    EngagementOrbViewController.prototype.showNotificationTooltipLine = function () {
        this.removeClass(this.LPViewMap.notificationTooltipState, this.engagementOrbStates.tooltipInfo);
        this.addClass(this.LPViewMap.notificationTooltipState, this.engagementOrbStates.tooltipLine);
    };

    EngagementOrbViewController.prototype.showNotificationTooltipInfo = function () {
        this.removeClass(this.LPViewMap.notificationTooltipState, this.engagementOrbStates.tooltipLine);
        this.addClass(this.LPViewMap.notificationTooltipState, this.engagementOrbStates.tooltipInfo);
    };

    EngagementOrbViewController.prototype.showNotificationTooltipInfoLoading = function () {
        this.showNotificationTooltipInfo();
        this.addClass(this.LPViewMap.orbState, this.engagementOrbStates.closingLoading);
    };

    EngagementOrbViewController.prototype.showNotificationTooltipStepUp = function () {
        this.showNotificationTooltipInfo();
        this.StepUpNotification = true;
    };

    EngagementOrbViewController.prototype.hideLoading = function () {
        if (this.closeTime) {
            clearTimeout(this.closeTime);
        }
        this.closeTooltip();
        this.removeClass(this.LPViewMap.orbState, this.engagementOrbStates.closingLoading);
        this.closeTime = null;
    };

    EngagementOrbViewController.prototype.clearAdditionalOrbStates = function () {
        this.removeClass(this.LPViewMap.orbState, [this.engagementOrbStates.closingLoading, this.engagementOrbStates.warning]);
        this.stopEngagementOrbTimer();
    };

    EngagementOrbViewController.prototype.setNotificationTooltipAutoCloseTime = function (timeout, hideOrbWhenDone) {
        var that = this;
        if (this.closeTime) {
            clearTimeout(this.closeTime);
        }
        this.closeTime = setTimeout(function () {
            if (that.disposed) {
                return;
            }
            that.closeTime = null;
            that.closeTooltip(that);
            if (hideOrbWhenDone) {
                that.lpHide();
                that.clearAdditionalOrbStates();
            }
            that = null;
        }, timeout);
    };

    EngagementOrbViewController.prototype.setNotificationTooltipInfo = function (data) {
        var notificationToolTipText = this.getFirstElement(this.LPViewMap.notificationTooltipText);

        var text = '';
        if (data.isImage) {
            text = '[' + this.translate('photo_sharing_image_caption') + ']';
            text += data.text ? ' "' + lpUtils.stripHTML(data.text) + '"': '';
        } else if (data.isAudio) {
            text = this.translate('audio_messaging_notification');
        }
        else if (data.text) {
            text = lpUtils.stripHTML(data.text) || '';
        }
        else if (data.isRichContent || data.textType === 'rich-content') {
            text = '[' + this.translate('structured_content_plain_text') + ']';
        }

        if (notificationToolTipText.innerText !== undefined) {
            notificationToolTipText.innerText = text;
        } else {
            notificationToolTipText.textContent = text;
        }
        this.StepUpNotification = false;
    };

    EngagementOrbViewController.prototype.createNotificationTooltip = function () {
        if (!this.notificationTooltipCreated) {
            this.createView({
                templateFile: 'LP_quick_response_bubble.html',
                target: this.LPViewMap.notificationTooltip
            });
            this.bindViewEvent({selector : this.LPViewMap.notificationTooltipClose, DOMEvent : "click", callback : this.closeTooltip});
            this.notificationTooltipCreated = true;
        }
    };

    EngagementOrbViewController.prototype.setTimeStamp = function (time) {
        if (this.ShowTimer) {
            //we should pass the time only after F5 (when we develop that)
            this.initializeTimer();
        } else if (this.asyncMessaging) {
            this.setMessagingSla();
        } else {
            this.getFirstElement(this.LPViewMap.orbNotificationTimestamp).innerHTML = this.formatTime(time);
        }
    };

    EngagementOrbViewController.prototype.lpBlur = function () {
        if (this.focused) {
            this.blurOrb();
        }
        this.previouslyFocused = false;
    };

    EngagementOrbViewController.prototype.lpFocus = function () {
        if (!this.focused) {
            this.clearNotificationCounter();
            if (!this.StepUpNotification) {
                this.closeTooltip();
            }
            this.focusOrb();
            if (this.ShowTimer && this.StopTimerOnFocus) {
                this.stopEngagementOrbTimer();
            }
        }
        this.previouslyFocused = false;
    };

    EngagementOrbViewController.prototype.externalVisibilityChanged = function (newFocusLevel) {
        function isBrowserTabVisible(comparisonLevel) {
            // checking the base level according to the defaults
            var baseLevel = 1;
            var constLE = agentLEManager.getLEConst();
            if (constLE && constLE.FOCUS_STATUS && constLE.FOCUS_STATUS.VISIBLE_NOT_FOCUSED) {
                baseLevel = constLE.FOCUS_STATUS.VISIBLE_NOT_FOCUSED;
            }
            // comparing the new level to the base level
            return comparisonLevel >= baseLevel;
        }

        var newVisibilityState = isBrowserTabVisible(newFocusLevel);
        // we only act when the external visibility changes
        if (this.externalVisible !== newVisibilityState) {
            this.externalVisible = newVisibilityState;
            if (this.externalVisible) {
                // if we've become visible
                if (this.previouslyFocused && !this.focused) {
                    this.lpFocus();
                }
            } else {
                // if we've stopped being visible
                if (this.focused) {
                    this.lpBlur();
                    this.previouslyFocused = true;
                }
            }
        }
    };

    EngagementOrbViewController.prototype.closeTooltip = function (event) {
        if (this.notificationTooltipCreated && this.notificationTooltipShowing) {
            var notificationTooltipStateElement = this.getFirstElement(this.LPViewMap.notificationTooltipState);
            this.removeClass(notificationTooltipStateElement, [this.engagementOrbStates.tooltipLine, this.engagementOrbStates.tooltipInfo]);
            this.removeClass(this.LPViewMap.orbState, this.LPClassesMap.tooltipOn);
            notificationTooltipStateElement = null;
            this.notificationTooltipShowing = false;
            this.StepUpNotification = false;
        }
        if (event) {
            event.preventFireUIEvent = true;
        }
    };

    EngagementOrbViewController.prototype.handleEngagementStateChanged = function (data) {
        if (this.disposed === true) {
            return;
        }
        switch (data.newValue) {
            case this.engagementStates.inactive:
                if (this.focused || !this.chatsResumed) {
                    this.lpHide();
                } else {
                    this.notifyEngagementEnd();
                }
                this.engagementState = this.engagementStates.inactive;
                break;
            case this.engagementStates.active:
                if (this.engagementState === this.engagementStates.inactive && this.closeTime) {
                    this.hideLoading();
                }
                this.lpShow();
                this.engagementState = this.engagementStates.active;
                this.notifyOnNewEngagement();
                break;
            case this.engagementStates.completed:
                if (this.focused || !this.chatsResumed) {
                    this.lpHide();
                } else {
                    this.notifyEngagementEnd();
                }
                this.engagementState = this.engagementStates.completed;
                break;
        }
    };

    EngagementOrbViewController.prototype.notifyEngagementEnd = function () {
        var infoMessage = {};
        infoMessage.type = this.engagementOrbStates.tooltipInfoLoading;
        infoMessage.text = this.getEngagementEndNotificationText();
        infoMessage.hideOrbWhenDone = true;
        this.showNotificationToolTip(infoMessage);
        infoMessage = null;
    };

    EngagementOrbViewController.prototype.onStepUp = function (data) {
        if (data.visitorId === this.visitorId) {
            var infoMessage = {};
            infoMessage.type = this.engagementOrbStates.tooltipStepUp;
            infoMessage.text = this.translate('engagementOrbStepUpNotification');
            infoMessage.timeout = 1000 * 60 * 60 * 24; // 24 hours
            this.showNotificationToolTip(infoMessage);
        }
    };

    EngagementOrbViewController.prototype.getEngagementEndNotificationText = function () {
        var notificationText, closeReason;
        if (this.asyncMessaging) {
            closeReason = this.getModelParam('chats.' + this.chatId + '.chatInfo.closeReason');
            switch (closeReason) {
                case lpTag.WebAgent.logicController.conversationCloseReasons.AGENT:
                    notificationText = this.translate("conversationOrbAgentManagerClosedConnectionNotification");
                    break;
                case lpTag.WebAgent.logicController.conversationCloseReasons.TIMEOUT:
                case lpTag.WebAgent.logicController.conversationCloseReasons.SYSTEM:
                    notificationText = this.translate("conversationOrbAutoClosedConnectionNotification");
                    break;
                default:    //CONSUMER
                    notificationText = this.translate("conversationOrbConsumerClosedConnectionNotification");
            }
        } else {
            notificationText = this.translate("engagementOrbChatClosedConnectionNotification");
        }
        return notificationText;
    };

    EngagementOrbViewController.prototype.lpShow = function (view, parentScope, animate) {
        this.changeLpVisibility(true, view, parentScope, animate);
    };

    EngagementOrbViewController.prototype.lpHide = function (view, parentScope, animate) {
        this.changeLpVisibility(false, view, parentScope, animate);
    };

    EngagementOrbViewController.prototype.changeLpVisibility = function (show, view, parentScope, animate) {
        view = view || this.view;
        var wasVisible = this.visible;
        if (show) {
            ViewController.prototype.lpShow.call(this, view, parentScope, animate);
        } else {
            ViewController.prototype.lpHide.call(this, view, parentScope, animate);
        }
        if (view === this.view) {
            if (wasVisible !== show) {
                this.viewEventsHandler.fireEvent({appName : this.visitorId, UIEvent : this.eventType.VISITOR_VISIBILITY_CHANGED, eventData: show});
            }
        }
    };

    EngagementOrbViewController.prototype.notifyOnNewEngagement = function () {
        var lastChatline;
        if (!this.focused && this.chatsResumed) {
            if (this.asyncMessaging && this.isAutoOpen) {
                this.logger.info('new async-messaging engagement with auto-open', 'notifyOnNewEngagement');
                // this flow is activated when a single orb is open and focused, and a consumer sends a message that shows another orb that's in blurred state
                lastChatline = _.last(this.getModelParam('chats.' + this.chatId + '.newChatLine.lines'));
                if (lastChatline && this.isActiveParticipant(this.chatId)) {
                    this.showNotificationToolTip(lastChatline);
                }
            } else {
                this.notifyAutoAccepted();
            }
        }
    };

    EngagementOrbViewController.prototype.notifyAutoAccepted = function () {
        if (this.isAutoAccepted && !this.focused && this.chatsResumed) {
            this.logger.info('new engagement with auto-answering', 'notifyOnNewEngagement');
            this.clearNotificationCounter();
            this.notifyOrb(true);
            this.setTimeStamp(this.getModelParam("chats." + this.chatId + ".chatInfo.startTime"));
            var key = this.asyncMessaging ? 'newConversationReceivedTooltip' : 'newChatReceivedTooltip';
            this.showNotificationToolTip({
                type: this.engagementOrbStates.tooltipLine,
                text: this.translate(key)
            });
        }
    };

    EngagementOrbViewController.prototype.onNewAcceptedEngagement = function (data) {
        if (data && data.visitorId === this.visitorId) {
            this.isAutoAccepted = data.isAutoAccepted;
            this.notifyAutoAccepted();
        }
    };

    EngagementOrbViewController.prototype.handleChatsResumeState = function (data) {
        if (typeof data.newValue !== 'undefined') {
            this.chatsResumed = typeof data.newValue !== 'undefined';
        }
    };

    EngagementOrbViewController.prototype.initializeTimer = function (startTime) {
        if (this.ShowTimer && !this.timerIsActive) {
            this.timerIsActive = true;
            this.addClass(this.LPViewMap.orbNotificationTimestamp, this.engagementOrbStates.timer);
            if (!this.timerView) {
                this.timerView = this.createView({
                    templateFile: "LP_timer_view.html",
                    target: this.LPViewMap.orbNotificationTimestamp
                });
            }
            var secondsSinceStart = 0;
            if (startTime) {
                secondsSinceStart = getSecondsFromStartTime(startTime);
            }
            this.startEngagementOrbTimer(secondsSinceStart);
        }

        function getSecondsFromStartTime(startTime) {
            var currentTimeInMilli = new Date().getTime();
            var startTimeInMilli = lpUtils.createDate(startTime, lpUtils.FORMAT_TYPES.ENGAGEMENT_WINDOW).getTime();
            var secondsSinceStart = (currentTimeInMilli - startTimeInMilli) / 1000;
            secondsSinceStart = Math.floor(secondsSinceStart);
            return secondsSinceStart;
        }
    };

    EngagementOrbViewController.prototype.startEngagementOrbTimer = function (startCount) {
        if (this.ShowTimer) {
            this.timerCount = 0;
            if (startCount && startCount > 0) {
                this.timerCount = startCount;
            }
            this.setEngagementOrbTimer();
            this.registerToTimer({context: this, callback: this.incrementEngagementOrbTimer, interval: 1}); //run until stopped, every 1 sec
        }
    };

    EngagementOrbViewController.prototype.incrementEngagementOrbTimer = function (data) {
        if (this.ShowTimer && typeof this.timerCount !== 'undefined') {
            this.timerCount++;
            this.setEngagementOrbTimer();
        }
    };

    EngagementOrbViewController.prototype.setEngagementOrbTimer = function () {
        if (!this.timerElement) {
            this.timerElement = this.getFirstElement(this.LPViewMap.orbNotificationTimer, this.LPViewMap.orbNotificationTimestamp);
        }
        if (this.timerElement) {
            this.timerElement.innerHTML = this.parseSecondsToTime(this.timerCount);
        }
    };

    EngagementOrbViewController.prototype.setMessagingSla = function () {
        if (this.asyncMessaging && this.chatId) {
            this.getFirstElement(this.LPViewMap.orbNotificationTimestamp).innerHTML = this.getModelParam('chats.' + this.chatId + '.chatInfo.SlaTexts.text');
        }
    };

    EngagementOrbViewController.prototype.stopEngagementOrbTimer = function () {
        if (this.ShowTimer) {
            this.removeClass(this.LPViewMap.orbNotificationTimestamp, this.engagementOrbStates.timer);
            this.unregisterTimer({context: this, callback: this.incrementEngagementOrbTimer});
            this.timerIsActive = false;
        }
    };


    EngagementOrbViewController.prototype.hideEngagement = function () {
        lpTag.WebAgent.logicController.disposeParticipant(this.visitorId);
        this.viewEventsHandler.fireEvent({appName: this.visitorId, UIEvent: this.eventType.VISITOR_DISPOSED, eventData: {visitorId: this.visitorId}, deleteOnFire: true});
    };


    EngagementOrbViewController.prototype.isActiveParticipant = function (chatId) {
        var logic = lpTag.WebAgent.logicController;
        var activeDialogId = logic.getActiveDialogIdOfConversation(this.chatId);
        return logic.isAcceptedEngagementByChatId(chatId) || logic.isLoggedInAgentManagerParticipant(chatId, activeDialogId);
    };

    EngagementOrbViewController.prototype.onCoBrowseNotification = function (event) {
        var context = this;

        if (event && event.data && event.data.visitorId === this.visitorId && event.data.type === 'stateChange') {
            switch (event.data.state) {
                case 'active':
                    this.addClass(this.LPViewMap.orbState, this.engagementOrbStates.cobrowsing);
                    break;

                case 'inactive':
                    this.removeClass(this.LPViewMap.orbState, this.engagementOrbStates.cobrowsing);
                    break;

                default:
                    this.removeClass(this.LPViewMap.orbState, this.engagementOrbStates.cobrowsing);
                    break;
            }

            if (event.data.message && this.isTranslated(event.data.message)) {
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
                var visitorName = this.getModelParam(participantPath + ".participantInfo.visitorName");

                var notificationMessage = this.translateObj(event.data.message, [{key: visitorName}]);
                notifyCoBrowseSessionState.call(this, notificationMessage);
            }
        }

        function notifyCoBrowseSessionState(notificationMessage) {
            if (!context.focused)
            {
                context.showNotificationToolTip({
                    type: context.engagementOrbStates.tooltipInfo,
                    text: notificationMessage,
                    hideOrbWhenDone: false
                });
            }
        }
    };

    return EngagementOrbViewController;

});
